import { validateEmail } from 'utils/validation/validators'

type ValidateMailOnCustomFormParams = {
  mail: string
  isRequired?: boolean
}

export default function validateMailOnCustomForm({ mail, isRequired }: ValidateMailOnCustomFormParams) {
  let error = ''
  if (isRequired && !mail) {
    error = 'Este campo é obrigatório'
  }

  if (mail && !validateEmail(mail)) {
    error = 'Este email está incorreto.'
  }
  return error
}
